// src/pages/leave-management/leaveUtils.js

import { capitalize } from 'lodash';

/**
 * Maps the `identityContext` from the policy data to the correct 'name'
 * parameter required by the useGetLynFormDataMutation hook.
 */
export const contextToQueryNameMap = {
	band: 'Bands',
	position: 'leavePolicyPositions',
	function: 'leavePolicyFunctions',
	userId: 'leavePolicyUsers',
	// Add other contexts here if they exist
};

// --- Shared Label/Value Options ---

export const leaveCategoryOptions = [
	{ key: 1, label: 'Regular Leave', value: 'regular' },
	{ key: 2, label: 'Special Leave', value: 'special' },
	{ key: 3, label: 'Leave Governance', value: 'governance' },
];

export const leaveTypeOptions = [
	{ key: 1, label: 'Annual Leave', value: 'annual' },
	{ key: 2, label: 'Sick Leave', value: 'sick' },
	{ key: 3, label: 'Casual Leave', value: 'casual' },
	{ key: 4, label: 'Maternity Leave', value: 'maternity' },
	{ key: 5, label: 'Paternity Leave', value: 'paternity' },
	{ key: 6, label: 'Religious Leave', value: 'religious' },
	{ key: 7, label: 'Study Leave', value: 'study' },
	{ key: 8, label: 'Compensatory Leave', value: 'compensatory' },
	{ key: 9, label: 'Carryovers', value: 'carryovers' },
	{ key: 10, label: 'Leave Encashment', value: 'leaveEncashment' },
	{ key: 11, label: 'Probation Period', value: 'probationPeriod' },
	{ key: 12, label: 'Leave Accrual', value: 'leaveAccrual' },
];

/**
 * A helper function to find a label from an array of options.
 * @param {Array} options - The array of {label, value} objects.
 * @param {String} value - The value to search for.
 * @returns {String} - The found label or a capitalized version of the value.
 */
export const findLabelByValue = (options, value) => {
	const found = options.find((opt) => opt.value === value);
	return found ? found.label : capitalize(value);
};
